import { type ChangeEvent, type ReactElement } from 'react'
import type CheckboxProps from './checkbox.props'
import * as S from './checkbox.styled'

export default function Checkbox ({
  label,
  name,
  onChange,
  required = false
}: CheckboxProps): ReactElement {
  const handleChange = ({ target: { checked, name } }: ChangeEvent<HTMLInputElement>): void => {
    onChange((prevValue: any) => ({ ...prevValue, [name]: checked }))
  }

  return <S.Container>
    <S.Checkbox
      id={name}
      name={name}
      onChange={handleChange}
      required={required}
      value={name}
      type="checkbox"
    />
    <S.Label htmlFor={name}>{label}</S.Label>
  </S.Container>
}
